module.exports = __webpack_public_path__ + "img/23_88.7fbb2fd2.png";